import {
	type LucideIcon as Icon, // Use LucideIcon aliased as Icon
	Camera,
	BarChart, // Use BarChart from lucide-react
	LayoutDashboard, // Use LayoutDashboard from lucide-react
	Database,
	FileCode, // Use FileCode for AI/FileAi
	FileText, // Use FileText for FileDescription and FileWord
	// FileWord, // Keep FileWord if appropriate, or find Lucide equivalent if needed - Replaced with FileText
	Folder,
	HelpCircle, // Use HelpCircle from lucide-react
	ListChecks, // Use ListChecks from lucide-react
	List, // Use List for ListDetails
	FileBarChart, // Use FileBarChart for Report
	Search,
	Settings,
	Users,
	KeyRound, // Use KeyRound from lucide-react
	Link, // Keep Link from lucide-react
	Package, // Added for Products
	Ticket, // Added for Activation Codes
} from 'lucide-react'

interface NavItem {
	key: string
	url: string
	icon: Icon
	isActive?: boolean
	items?: SubNavItem[]
}

interface SubNavItem {
	key: string
	url: string
}

interface UserData {
	name: string
	email: string
	avatar: string
}

interface DocumentItem {
	key: string
	url: string
	icon: Icon
}

interface SidebarData {
	user: UserData
	navMain: NavItem[]
	navClouds: NavItem[]
	navSecondary: NavItem[]
	documents: DocumentItem[]
	management: DocumentItem[]
}

export const sidebarData: SidebarData = {
	user: {
		name: 'shadcn',
		email: 'm@example.com',
		avatar: '/avatars/shadcn.jpg',
	},
	navMain: [
		{
			key: 'sidebar.main.dashboard',
			url: '/dashboard',
			icon: LayoutDashboard,
		},
		{
			key: 'sidebar.main.myActivationCodes',
			url: '/my-codes',
			icon: KeyRound,
		},
	],
	navClouds: [], // Initialize navClouds as an empty array
	navSecondary: [
		{
			key: 'sidebar.secondary.settings',
			url: '/dashboard/settings/profile', // Add prefix
			icon: Settings,
		},
		// {
		// 	key: 'settings.apiKeys.title',
		// 	url: '/dashboard/settings/api-keys', // Add prefix
		// 	icon: KeyRound,
		// },
		{
			key: 'sidebar.secondary.help',
			url: '#',
			icon: HelpCircle,
		},
		{
			key: 'sidebar.secondary.search',
			url: '#',
			icon: Search,
		},
	],
	management: [
		{
			key: 'sidebar.management.products',
			url: '/dashboard/admin/activation/products',
			icon: Package,
		},
		{
			key: 'sidebar.management.activationCodes',
			url: '/dashboard/admin/activation/codes',
			icon: Ticket,
		},
	],
	documents: [
		{
			key: 'sidebar.documents.dataLibrary',
			url: '#',
			icon: Database,
		},
		{
			key: 'sidebar.documents.reports',
			url: '#',
			icon: FileBarChart,
		},
		{
			key: 'sidebar.documents.wordAssistant',
			url: '#',
			icon: FileText, // Replaced FileWord with FileText
		},
	],
}
